const brandHistory = {
    timeline: {
        2016: {
            title: 2016,
            products: [
                {
                    title: "Bobby",
                    slug: "xddesign-bobby",
                    year: 2016,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2017: {
            title: 2017,
            products: [
                {
                    title: "Bobby Compact",
                    slug: "xd-design-bobby-compact",
                    year: 2017,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Bizz",
                    slug: "xd-design-bobby-bizz",
                    year: 2017,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2018: {
            title: 2018,
            products: [
                {
                    title: "Bobby XL",
                    slug: "xd-design-bobby-xl",
                    year: 2018,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Urban",
                    slug: "xd-design-bobby-urban",
                    year: 2018,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Urban Lite",
                    slug: "xd-design-bobby-urban-lite",
                    year: 2018,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2019: {
            title: 2019,
            products: [
                {
                    title: "Bobby Elle",
                    slug: "xd-design-bobby-elle",
                    year: 2019,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Duffle",
                    slug: "xd-design-bobby-duffle",
                    year: 2019,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Pro",
                    slug: "xd-design-bobby-pro",
                    year: 2019,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Tech",
                    slug: "xd-design-bobby-tech",
                    year: 2019,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Hero",
                    slug: "xd-design-bobby-hero-regular",
                    year: 2019,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2020: {
            title: 2020,
            products: [
                {
                    title: "Urban Bumbag",
                    slug: "xd-design-urban-bumbag",
                    year: 2020,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Trolley",
                    slug: "xd-design-bobby-trolley",
                    year: 2020,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Sling",
                    slug: "xd-design-bobby-sling",
                    year: 2020,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Soft",
                    slug: "xd-design-bobby-soft",
                    year: 2020,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2021: {
            title: 2021,
            products: [
                {
                    title: "Flex Gym Bag",
                    slug: "xd-design-flex-gym-bag",
                    year: 2021,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bobby Soft Art",
                    slug: "xd-design-bobby-soft-art",
                    year: 2021,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Flex Trolley",
                    slug: "xd-design-flex-trolley",
                    year: 2021,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2022: {
            title: 2022,
            products: [
                {
                    title: "Bobby Explore",
                    slug: "xd-design-bobby-explore",
                    year: 2022,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2023: {
            title: 2023,
            products: [
                {
                    title: "Bobby Bizz 2.0",
                    slug: "xd-design-bobby-bizz-2-0",
                    year: 2023,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Boxy Sling",
                    slug: "xd-design-boxy-sling",
                    year: 2023,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Bizz Backpack",
                    slug: "xd-design-bizz-backpack",
                    year: 2023,
                    isActive: false,
                    isVisible: false,
                },
                {
                    title: "Soft Daypack",
                    slug: "xd-design-soft-daypack",
                    year: 2023,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
        2024: {
            title: 2024,
            products: [
                {
                    title: "Bobby Edge",
                    slug: "xd-design-bobby-edge",
                    year: 2024,
                    isActive: false,
                    isVisible: false,
                },
            ],
            isActive: false,
            isVisible: false,
        },
    },
    products: [
        {
            title: "Bobby",
            date: "октябрь 2016",
            slug: "xddesign-bobby",
            image: "bobby",
            year: 2016,
            text: [
                "Первый рюкзак XD&nbsp;Design Bobby придумали для борьбы с&nbsp;карманниками в&nbsp;мегаполисах.",
                "Дизайнеры разработали уникальную конструкцию, которую невозможно открыть незаметно для владельца.",
                "В&nbsp;апреле 2016&nbsp;на Kickstarter рюкзак поддержали свыше 10&nbsp;000 бэкеров на&nbsp;сумму более 800&nbsp;000&nbsp;$.",
            ],
            template: "Bobby",
        },
        {
            title: "Bobby Compact",
            date: "июнь 2017",
            slug: "xd-design-bobby-compact",
            image: "bobby-compact",
            year: 2017,
            text: [
                "Рюкзак задумывался как более яркая версия Bobby.",
                "Первые модели 2017 года выпускались с&nbsp;передней панелью розового, салатового, желтого, голубого и&nbsp;синего цветов.",
                "Затем появилась линейка с&nbsp;камуфляжными принтами.",
            ],
            template: "Compact",
        },
        {
            title: "Bobby Bizz",
            date: "октябрь 2017",
            slug: "xd-design-bobby-bizz",
            image: "bobby-bizz",
            year: 2017,
            text: [
                "Трансформер Bobby Bizz&nbsp;&mdash; гибрид дипломата и&nbsp;бизнес-рюкзака.",
                "К&nbsp;фирменной конструкции добавили возможность менять способ переноски.",
                "Третье поколение рюкзаков Bobby также финансировали через Kickstarter.",
            ],
            template: "Bizz",
        },
        {
            title: "Bobby XL",
            date: "июнь 2018",
            slug: "xd-design-bobby-xl",
            image: "bobby-xl",
            year: 2018,
            text: [
                "Вместительная версия первого Bobby, о&nbsp;которой долго просили поклонники серии.",
                "Рюкзак обеспечил больше места для гаджетов и&nbsp;стал отличным компаньоном в&nbsp;поездках на&nbsp;пару дней.",
                "Свою роль сыграла система распределения веса, благодаря которой даже загруженный Bobby XL&nbsp;ощущается на&nbsp;20&ndash;25% легче.",
            ],
            template: "XL",
        },
        {
            title: "Bobby Urban",
            date: "июль 2018",
            slug: "xd-design-bobby-urban",
            image: "bobby-urban",
            year: 2018,
            text: [
                "Конструкция рюкзака значительно отличалась от&nbsp;предыдущих моделей. Это роллтоп: его верхняя часть закручивается и&nbsp;разворачивается.",
                "Защиту обеспечила непрорезаемая ткань и&nbsp;кодовый замок, который закрывает доступ к&nbsp;верхней молнии.",
                "Bobby Urban запустили на&nbsp;Kickstarter, где он&nbsp;собрал более 200&nbsp;000&nbsp;$.",
            ],
            template: "Urban",
        },
        {
            title: "Bobby Urban Lite",
            date: "июль 2018",
            slug: "xd-design-bobby-urban-lite",
            image: "bobby-urban-lite",
            year: 2018,
            text: [
                "Рюкзак стал упрощенной версией ролл-топа Urban. Модель обзавелась новым цветом. Ткань, хоть и&nbsp;осталась плотной, но&nbsp;уже не&nbsp;обеспечивала полной защиты от&nbsp;прорезания.",
                "Рюкзак был спроектирован для одновременной переноски ноутбука с&nbsp;диагональю до&nbsp;15,6 дюймов и&nbsp;12,9-дюймового планшета.",
            ],
            template: "UrbanLite",
        },
        {
            title: "Bobby Elle",
            date: "март 2019",
            slug: "xd-design-bobby-elle",
            image: "bobby-elle",
            year: 2019,
            text: [
                "Bobby Elle стал первым антикражным рюкзаком, созданным специально для девушек.",
                "Для модельного ряда была выбрана плотная водоотталкивающая экокожа и&nbsp;широкая линейка цветов.",
            ],
            template: "Elle",
        },
        {
            title: "Bobby Duffle",
            date: "август 2019",
            slug: "xd-design-bobby-duffle",
            image: "bobby-duffle",
            year: 2019,
            text: [
                "Рюкзак-трансформер разрабатывался для путешествий, с&nbsp;учетом стандартов ручной клади большинства авиакомпаний.",
                "Bobby Duffle можно носить за&nbsp;плечами, в&nbsp;руках и&nbsp;на&nbsp;плече: достаточно убрать ремни.",
                "Лямки соединяются нагрудной стяжкой, так что рюкзак не&nbsp;болтается и&nbsp;не&nbsp;мешает бежать к&nbsp;уходящему поезду.",
            ],
            template: "Duffle",
        },
        {
            title: "Bobby Pro",
            date: "сентябрь 2019",
            slug: "xd-design-bobby-pro",
            image: "bobby-pro",
            year: 2019,
            text: [
                "Bobby Pro был задуман как вместительный городской рюкзак для гаджетов.",
                "В&nbsp;основное отделение можно установить съемные разделители на&nbsp;липучках, которые идут в&nbsp;комплекте. Тогда для вещей появятся аккуратные &laquo;ячейки&raquo; по&nbsp;размеру.",
                "Чтобы сделать Bobby Pro, XD&nbsp;Design сотрудничала с&nbsp;компанией Fidlock, которая выпускает особый крепеж.<br>К&nbsp;лямкам можно &laquo;примагнитить&raquo; смартфон или бутылку с&nbsp;водой, и&nbsp;те&nbsp;всегда будут под рукой.",
            ],
            template: "Pro",
        },
        {
            title: "Bobby Tech",
            date: "октябрь 2019",
            slug: "xd-design-bobby-tech",
            image: "bobby-tech",
            year: 2019,
            text: [
                "Bobby Tech&nbsp;&mdash; это высокотехнологичный рюкзак для гаджетов со&nbsp;встроенной солнечной панелью. Панель преобразует энергию солнца в&nbsp;электричество и&nbsp;заряжает гаджеты на&nbsp;ходу.",
                "Еще одним технологическим новшеством стал встроенный модуль беспроводной зарядки.",
            ],
            template: "Tech",
        },
        {
            title: "Bobby Hero",
            date: "ноябрь 2019",
            slug: "xd-design-bobby-hero-regular",
            image: "bobby-hero",
            year: 2019,
            text: [
                "Линейка из&nbsp;трех противокражных рюкзаков разного размера и&nbsp;вместимости: Small, Regular и&nbsp;XL.",
                "Они стали долгожданным переосмыслением самого первого рюкзака от&nbsp;XD&nbsp;Design. Конструкция была оптимизирована, а&nbsp;сами рюкзаки лучше держат форму.",
            ],
            template: "Hero",
        },
        {
            title: "Urban Bumbag",
            date: "март 2020",
            slug: "xd-design-urban-bumbag",
            image: "urban-bumbag",
            year: 2020,
            text: [
                "Команда XD&nbsp;Design пристально следит за&nbsp;трендами. Когда поясные сумки стали модным мастхевом, дизайнеры порадовали поклонников собственной вариацией на&nbsp;эту тему.",
                "Сумку Urban Bumbag можно носить на&nbsp;поясе, на&nbsp;плече и&nbsp;через плечо.",
            ],
            template: "UrbanBumbag",
        },
        {
            title: "Bobby Trolley",
            date: "август 2020",
            slug: "xd-design-bobby-trolley",
            image: "bobby-trolley",
            year: 2020,
            text: [
                "Bobby Trolley добавили в&nbsp;линейку на&nbsp;волне популярности других трансформеров XD&nbsp;Design. Он&nbsp;превращается из&nbsp;практичного рюкзака в&nbsp;сумку на&nbsp;колесиках&nbsp;&mdash; и&nbsp;обратно, а&nbsp;также оснащен кодовым замком.",
                "При этом, Bobby Trolley подходит под требования, предъявляемые к&nbsp;ручной клади большинством авиакомпаний.",
            ],
            template: "Trolley",
        },
        {
            title: "Bobby Sling",
            date: "ноябрь 2020",
            slug: "xd-design-bobby-sling",
            image: "bobby-sling",
            year: 2020,
            text: [
                "Bobby Sling&nbsp;&mdash; однолямочный рюкзак. Был создан для тех, кто передвигается по&nbsp;городу налегке.",
                "Фирменная защита на&nbsp;месте: плотный рюкзак не&nbsp;прорезается, а&nbsp;до&nbsp;его молний нельзя добраться извне.",
            ],
            template: "Sling",
        },
        {
            title: "Bobby Soft",
            date: "декабрь 2020",
            slug: "xd-design-bobby-soft",
            image: "bobby-soft",
            year: 2020,
            text: [
                "Для рюкзака Bobby Soft команда XD&nbsp;Design выбрала необычный подход. Это рюкзак с&nbsp;мягким каркасом, объем которого регулируется от&nbsp;13&nbsp;до&nbsp;16&nbsp;литров.",
                "Верхняя часть рюкзака расширяется при помощи системы молний.<br>Сами молнии защищены специальным замком, который предотвращает расстегивание.",
            ],
            template: "Soft",
        },
        {
            title: "Flex Gym Bag",
            date: "апрель 2021",
            slug: "xd-design-flex-gym-bag",
            image: "flex-gym-bag",
            year: 2021,
            text: [
                "Gym Bag&nbsp;&mdash; первый рюкзак новой серии гибридных сумок Flex, гибко сочетающих разные задачи. Линейку запустили при помощи краудфандинговой платформы Kickstarter.",
                "Рюкзак меняет стиль с&nbsp;делового на&nbsp;спортивный одним движением молнии. На&nbsp;его передней панели находится складное отделение, которое расстегивается и&nbsp;раскрывается на&nbsp;всю длину.",
            ],
            template: "GymBag",
        },
        {
            title: "Bobby Soft Art",
            date: "сентябрь 2021",
            slug: "xd-design-bobby-soft-art",
            image: "bobby-soft-art",
            year: 2021,
            text: [
                "Soft Art во&nbsp;всем похож на&nbsp;обычный Soft. Отличие&nbsp;&mdash; только в&nbsp;ярких принтах.",
                "Разрабатывая эту лимитированную серию, дизайнеры вдохновлялись стилем и&nbsp;настроением Амстердама.",
            ],
            template: "SoftArt",
        },
        {
            title: "Flex Trolley",
            date: "октябрь 2021",
            slug: "xd-design-flex-trolley",
            image: "flex-trolley",
            year: 2021,
            text: [
                "Flex Trolley стал универсальным решением для перелетов, путешествий и&nbsp;повседневных поездок.<br>За&nbsp;несколько секунд он&nbsp;трансформируется из&nbsp;сумки для ручной клади в&nbsp;деловой чемодан. При этом внутренний объем увеличивается вдвое.",
            ],
            template: "FlexTrolley",
        },
        {
            title: "Bobby Explore",
            date: "декабрь 2022",
            slug: "xd-design-bobby-explore",
            image: "bobby-explore",
            year: 2022,
            text: [
                "Bobby Explore&nbsp;&mdash; самый вместительный рюкзак в&nbsp;линейке. Его объём расширяется до&nbsp;30&nbsp;литров, достаточно расстегнуть дополнительную молнию на&nbsp;одном из&nbsp;отделений.",
                "Модель стала надежным решением для поездок и&nbsp;путешествий. В&nbsp;трех отделениях хватает места и&nbsp;для техники, и&nbsp;для вещей на&nbsp;любую погоду.",
                "",
            ],
            template: "BobbyExplore",
        },
        {
            title: "Bobby Bizz 2.0",
            date: "апрель 2023",
            slug: "xd-design-bobby-bizz-2-0",
            image: "bobby-bizz-v2",
            year: 2023,
            text: [
                "Версия&nbsp;2.0&nbsp;&mdash; шаг в&nbsp;усовершенствовании популярной модели. Форму рюкзака удалось сделать эргономичнее, а&nbsp;внутреннее пространство&nbsp;&mdash; оптимизировать еще лучше. Цветовая линейка расширилась до&nbsp;3&nbsp;цветов.",
                "",
                "",
            ],
            template: "BizzV2",
        },
        {
            title: "Boxy Sling",
            date: "июль 2023",
            slug: "xd-design-boxy-sling",
            image: "boxy-sling",
            year: 2023,
            text: [
                "Boxy Sling&nbsp;&mdash; развитие идеи XD&nbsp;Design о&nbsp;многофункциональных сумках. Способы ношения ограничены только воображением: на&nbsp;поясе, на&nbsp;плече, через плечо, на&nbsp;шее.",
                "В&nbsp;компактном формате нашлось место удобной системе хранения и&nbsp;даже складному сетчатому карману для бутылки.",
            ],
            template: "BoxySling",
        },
        {
            title: "Bizz Backpack",
            date: "июль 2023",
            slug: "xd-design-bizz-backpack",
            image: "bizz-backpack",
            year: 2023,
            text: [
                "Bizz Backpack совместил в&nbsp;себе множество решений, которые отлично успели зарекомендовать себя в&nbsp;других моделях.",
                "Объем рюкзака изменяется в&nbsp;зависимости от&nbsp;задач. Система организации вещей состоит из&nbsp;скрытых отсеков, внутренних отделений и&nbsp;внешних карманов с&nbsp;быстрым доступом.",
                "С&nbsp;Bobby Bizz его роднит строгий стиль и&nbsp;дополнительная ручка на&nbsp;боку.",
            ],
            template: "BizzBackpack",
        },
        {
            title: "Soft Daypack",
            date: "октябрь 2023",
            slug: "xd-design-soft-daypack",
            image: "soft-daypack",
            year: 2023,
            text: [
                "Soft Daypack&nbsp;&mdash; это ответ на&nbsp;вопрос, каким должен быть универсальный городской рюкзак со&nbsp;множеством карманов. Визитная карточка модели&nbsp;&mdash; откидной верх. Он&nbsp;обеспечивается дополнительную защиту вещам в&nbsp;основном отделении: закрывается на&nbsp;магнитно-механический замок Fidlock.",
            ],
            template: "SoftDaypack",
        },
        {
            title: "Bobby Edge",
            date: "май 2024",
            slug: "xd-design-bobby-edge",
            image: "bobby-edge",
            year: 2024,
            text: [
                "2024 год стал годом Edge. Новый флагман городских рюкзаков XD&nbsp;Design&nbsp;&mdash; это переосмысление классических серий Bobby и&nbsp;Bobby Hero.",
                "Bobby Edge сочетает в&nbsp;себе удобство, безопасность и&nbsp;современные решения. У&nbsp;рюкзака нет внешних карманов, а&nbsp;внутренняя система хранения стала еще более продуманной.",
                "Каркас остался жестким, но&nbsp;форма стала эргономичнее, чтобы лучше соответствовать тенденциям нового десятилетия в&nbsp;дизайне.",
            ],
            template: "Edge",
        },
    ],
};

export { brandHistory };
